/**
 * ParticularOrderStatus
 * Auto-generated enum from C#
 */

export type ParticularOrderStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const ParticularOrderStatus = {
    NUEVO: 0 as ParticularOrderStatus,
    CONFIRMADO: 1 as ParticularOrderStatus,
    ASIGNADO: 2 as ParticularOrderStatus,
    ACEPTADO: 3 as ParticularOrderStatus,
    RECHAZADO: 4 as ParticularOrderStatus,
    EN_CURSO: 5 as ParticularOrderStatus,
    FINALIZADO: 6 as ParticularOrderStatus,
    CANCELADO: 7 as ParticularOrderStatus
};
